<template>
    <!--资讯列表-->
    <div class="news-work">
        <div class="news-wrapper wrapper" v-show="total > 0">
            <ul class="news-lists">
                <li class="flex-align-between" v-for="(li, index) in lists" :key="index" @click="gotoDetail(li)">
                    <img :src="li.cover" alt="" v-show="li.cover !== undefined">
                    <!-- :onerror="defaultCover"   -->
                    <div class="article">
                        <h3 class="f16 wes">{{ li.title }}</h3>
                        <p class="f12 wes-2">{{ li.introduction }}</p>
                        <div class="summary flex-align">
                            <span class="time">{{ li.createTime || '--' }}</span>
                            <span class="wes">来源：{{ li.source || '未知' }}</span>
                            <span class="wes">编辑：{{ li.author || '未知' }}</span>
                            <!-- <span class="wes">阅读量：{{li.time || 0}}</span> -->
                        </div>
                    </div>
                </li>
            </ul>
            <div class="more-btn" @click="more" :class="{ 'finish': btnText === '已无更多' }">
                {{ btnText }}
            </div>
        </div>
        <Empty :show="total == 0"></Empty>
        <!-- <scorllTop></scorllTop> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            btnText: '查看更多',
            lists: [],
            currentPage: 1,
            total: 0,
        }
    },
    watch: {
        $route(to, from) {
            console.log('路由变化了', this.$route.query.type);
            this.currentPage = 0;
            this.lists = [];
            this.btnText = '查看更多';
            if (this.$route.query.type == 1) {
                this.getNewsList(8)
            } else {
                this.getNewsList(6)
            }
        }
    },
    methods: {
        async getNewsList(clazz) {
            let params = {
                pageSize: 7,
                pageNum: this.currentPage++,
                isAsc: 'desc',
                clazz
            }
            let resData = await Api.Home.GetNewsList(params);
            console.log('新闻列表:', resData)
            if (JSON.stringify(resData.rows) == '[]' || resData.rows.length == resData.total) {
                this.showBtn = false;
                this.btnText = '已无更多';
            }
            this.total = resData.total;
            this.lists = this.lists.concat(resData.rows);
            this.changeBreadName();
        },
        async gotoDetail(item) {
            this.$router.push(`news/detail/${item.id}?type=${this.$route.query.type}&breadNumber=3`)
        },
        changeBreadName() {
            let labelList = this.$store.state.basics.newsLabelList;
            // console.log('新闻labelList',this.$store.state.basics.breadList);
            let labelName = '';
            labelList.map(item => {
                if (item.dictValue == this.$route.query.clazz) {
                    labelName = item.label
                }
            })
            // console.log('新闻labelList',labelName);
            this.$store.commit('breadPageNameChange', labelName)
        },
        more() {
            if (this.btnText == '已无更多') {
                return
            } else {
                if (this.$route.query.type == 1) {
                    this.getNewsList(8)
                } else {
                    this.getNewsList(6)
                }
            }
        }
    },
    mounted() {
        scroll(0, 0)
        if (this.$route.query.type == 1) {
            this.getNewsList(8)
        } else {
            this.getNewsList(6)
        }
    },
}
</script>

<style lang="less" scoped>
@basisColor: #508EF9;
@bgColor: #FAFAFA;
@white: #fff;

.news-work {
    background-color: @bgColor !important;
    min-height: 100vh;

    .news-wrapper {
        background-color: #fff;
        border-radius: 8px;
        margin-bottom: 100px;
        overflow: hidden;
        min-height: 100vh;
    }

    .news-lists {
        padding: 0 24px 0 19px;

        li {
            padding: 35px 7px 35px 14px;
            border-bottom: 1px solid #ebebeb;
            cursor: pointer;

            &:hover * {
                color: #508EF9;
            }

            &:last-child {
                border-bottom: 0;
                padding-bottom: 0;
            }
        }

        img {
            display: inline-block;

            margin-right: 26px;
            width: 199px;
            height: 119px;

            background-color: @bgColor;
        }
    }

    .article {
        flex: 1;
        width: 0;
        padding: 7px 0;

        h3 {
            font-size: 15px;
            font-weight: bold;
        }

        p {
            margin: 20px 0;
            color: #999;
            font-size: 12px;
            line-height: 24px;
        }
    }

    .summary span {
        font-size: 12px;
        color: #999;
        flex-basis: 20%;
        flex-shrink: 0;
        margin-right: 15px;
    }

    .more-btn {
        display: block;

        margin: 38px auto 21px;
        border: 1px solid @basisColor;
        border-radius: 3px;
        line-height: 25px;
        width: 100px;

        font-size: 12px;

        color: @basisColor;

        text-align: center;
        cursor: pointer;

        &:hover {
            background-color: #508EF9;
            color: #fff;
        }
    }

    .finish {
        border: 1px solid #DFDFDF;

        color: #777;

        &:hover {
            background-color: transparent;
            color: #777;
        }
    }

    @media screen and (min-width:1250px) {
        .news-lists {
            padding: 0 29px 0 23px;

            li {
                padding: 42px 9px 42px 17px;
            }

            img {
                margin-right: 32px;
                width: 242px;
                height: 144px;

            }
        }

        .article {
            padding: 9px 0;

            h3 {
                font-size: 18px;
            }

            p {
                margin: 10px 0 30px;
                font-size: 14px;
            }
        }

        .more-btn {
            margin: 50px auto 21px;
            line-height: 30px;
            width: 120px;

            font-size: 13px;

        }

    }
}

@media screen and (max-width: 600px) {
    .news-work {
        background-color: @bgColor !important;
        width: 1200px;
        min-height: 200vh;

        .news-wrapper {
            background-color: #fff;
            border-radius: 8px;
            margin-bottom: 30px;
            overflow: hidden;
            min-height: 200vh;
        }

        .news-lists {
            padding: 0 24px 0 19px;

            li {
                padding: 35px 7px 35px 14px;
                border-bottom: 1px solid #ebebeb;
                cursor: pointer;

                &:hover * {
                    color: #508EF9;
                }

                &:last-child {
                    border-bottom: 0;
                    padding-bottom: 0;
                }
            }

            img {
                display: inline-block;

                margin-right: 26px;
                width: 199px;
                height: 119px;

                background-color: @bgColor;
            }
        }

        .article {
            flex: 1;
            width: 0;
            padding: 7px 0;

            h3 {
                font-size: 15px;
                font-weight: bold;
            }

            p {
                margin: 20px 0;
                color: #999;
                font-size: 12px;
                line-height: 24px;
            }
        }

        .summary span {
            font-size: 12px;
            color: #999;
            flex-basis: 20%;
            flex-shrink: 0;
            margin-right: 15px;
        }

        .more-btn {
            display: block;

            margin: 38px auto 21px;
            border: 1px solid @basisColor;
            border-radius: 3px;
            line-height: 25px;
            width: 100px;

            font-size: 12px;

            color: @basisColor;

            text-align: center;
            cursor: pointer;

            &:hover {
                background-color: #508EF9;
                color: #fff;
            }
        }

        .finish {
            border: 1px solid #DFDFDF;

            color: #777;

            &:hover {
                background-color: transparent;
                color: #777;
            }
        }
    }
}

@media screen and (min-width:1250px) {
    .news-lists {
        padding: 0 29px 0 23px;

        li {
            padding: 42px 9px 42px 17px;
        }

        img {
            margin-right: 32px;
            width: 242px;
            height: 144px;

        }
    }

    .article {
        padding: 9px 0;

        h3 {
            font-size: 18px;
        }

        p {
            margin: 10px 0 30px;
            font-size: 14px;
        }
    }

    .more-btn {
        margin: 50px auto 21px;
        line-height: 30px;
        width: 120px;

        font-size: 13px;

    }

}
</style>